let apidaeQuickSearch = {
        props: {
            title: String,
            type: String,
            typeFiltre: String,
            params: Object,
            groupesFiltres: Array,
            lang: String,
            pmin: Number,
            pmax: Number,
            njmin: Number,
            njmax: Number,
            showDate: Number,
            showTarif: Number,
            showFiltreResults: Number,
            showFiltreLib: Number,
            showFiltreGroupes: Number,
            showFiltreDate: Number,
            showFiltreAge: Number,
            showFiltrePrice: Number,
            showFiltreCapacity: Number,
            showFiltreNombreChambres: Number,
            showFiltreNombreJours: Number,
            showFiltreNombreNuits: Number,
            showFiltreDistance: Number,
            showFiltreDuration: Number,
            showFiltreElevation: Number,
            suggestions: Array
        },
        computed: {
            currentDate: function() {
                return new Date().toJSON().slice(0, 10);
            }
        },
        components: {
            groupFilters,
            filterLib,
            filtreDate,
            filtrePrice,
            filtreNombreJours
        },
        directives: {
            clickaway
        },
        data() {
            return {
                isDropdownActive: false,
                selection: ''
            }
        },
        methods: {
            save() {
                this.$root.submitfilters(event)
            },
            datevent() {
                this.$root.callfilters(event)
            },
            pricevent() {
                this.$root.callfilters(event)
                this.isDropdownActive = false
            },
            away() {
                this.isDropdownActive = false;
            }
        },
        template: `
    <div class="Profiles">
        <form @submit.prevent="save">
            <h2 class="h2">{{ title }}</h2>
            <div class="profile-vertical">
                <template v-if="showFiltreLib">
                    <filter-lib :suggestions="suggestions" v-model="selection"></filter-lib>
                </template>
                <template v-if="showFiltreGroupes && !groupeFiltres.hide" v-for="(groupeFiltres, index) in groupesFiltres">
                    <group-filters :groupe-filtres="groupeFiltres"></group-filters>
                </template>
                <filtre-price v-if="showFiltrePrice" :pmin="pmin" :pmax="pmax" />
                <filtre-nombre-jours v-if="showFiltreNombreJours" :njmin="njmin" :njmax="njmax" />
                <filtre-date v-if="showFiltreDate" :params="params" />
                <div v-if="showFiltreResults">
                    <button class="button" type="submit">Voir les {{ params.nbPrestas }} résultats</button>
                </div>
            </div>
        </form>
    </div>`
    }
    // <div class="profile filter-block" :class="{ 'is-active': isDropdownActive }">
    //     <h4 @click="isDropdownActive=!isDropdownActive" :class="(pmin != 0 || pmax != 10000) ? 'selected' : ''">Mon budget</h4>
    //     <div class="filter-content filter-price filters list">
    //         <ul>
    //             <li :class="(pmin == '0' && pmax == '10000') ? 'selected filter' : 'filter'">
    //                 <span @click="pricevent" class="pricevent filter-rbl" data-pmin="0" data-pmax="10000">Tous les prix</span>
    //             </li>
    //             <li :class="(pmin == '0' && pmax == '100') ? 'selected filter' : 'filter'">
    //                 <span @click="pricevent" class="pricevent filter-rbl" data-pmin="0" data-pmax="100">Moins de 100€</span>
    //             </li>
    //             <li :class="(pmin == '100' && pmax == '200') ? 'selected filter' : 'filter'">
    //                 <span @click="pricevent" class="pricevent filter-rbl" data-pmin="100" data-pmax="200">De 100€ à 200€</span>
    //             </li>
    //             <li :class="(pmin == '200' && pmax == '10000') ? 'selected filter' : 'filter'">
    //                 <span @click="pricevent" class="pricevent filter-rbl" data-pmin="200" data-pmax="10000">Supérieur à 200€</span>
    //             </li>
    //         </ul>
    //         <div class="input-number">
    //             <input type="hidden" name="pmin" id="min-number-price" class="min-number autosize" v-model="pmin">
    //             <input type="hidden" name="pmax" id="max-number-price" class="max-number autosize" v-model="pmax">
    //         </div>
    //     </div>
    // </div>

//https://embed.plnkr.co/plunk/8XdCd2
if (document.querySelector('.prestaQuickSearch')) {
    document.querySelectorAll('.prestaQuickSearch').forEach(i => {
        let id = i.getAttribute('id');
        let uri = i.dataset.url;
        let title = i.dataset.title;
        let type = i.dataset.type;
        let typeFiltre = i.dataset.typefiltre;
        let lang = i.dataset.lang;
        let showDate = parseInt(i.dataset.showdate);
        let showTarif = parseInt(i.dataset.showtarif);
        let showFiltre = parseInt(i.dataset.showfiltre);
        let showFiltreResults = parseInt(i.dataset.showfiltreresults);
        let showFiltreLib = parseInt(i.dataset.showfiltrelib);
        let showFiltreGroupes = parseInt(i.dataset.showfiltregroupes);
        let showFiltreDate = parseInt(i.dataset.showfiltredate);
        let showFiltreAge = parseInt(i.dataset.showfiltreage);
        let showFiltrePrice = parseInt(i.dataset.showfiltreprice);
        let showFiltreCapacity = parseInt(i.dataset.showfiltrecapacity);
        let showFiltreNombreChambres = parseInt(i.dataset.showfiltrenombrechambres);
        let showFiltreNombreJours = parseInt(i.dataset.showfiltrenombrejours);
        let showFiltreNombreNuits = parseInt(i.dataset.showfiltrenombrenuits);
        let showFiltreDistance = parseInt(i.dataset.showfiltredistance);
        let showFiltreDuration = parseInt(i.dataset.showfiltreduration);
        let showFiltreElevation = parseInt(i.dataset.showfiltreelevation);
        new Vue({
            el: '#' + id,
            components: { apidaeQuickSearch },
            data: function() {
                return {
                    loading: true,
                    title: title,
                    type: type,
                    typeFiltre: typeFiltre,
                    params: {},
                    groupesFiltres: [],
                    lang: lang,
                    pmin: 0,
                    pmax: 10000,
                    njmin: 0,
                    njmax: 1000,
                    showDate: showDate,
                    showTarif: showTarif,
                    showFiltre: showFiltre,
                    showFiltreResults: showFiltreResults,
                    showFiltreLib: showFiltreLib,
                    showFiltreGroupes: showFiltreGroupes,
                    showFiltreDate: showFiltreDate,
                    showFiltreAge: showFiltreAge,
                    showFiltrePrice: showFiltrePrice,
                    showFiltreCapacity: showFiltreCapacity,
                    showFiltreNombreChambres: showFiltreNombreChambres,
                    showFiltreNombreJours: showFiltreNombreJours,
                    showFiltreNombreNuits: showFiltreNombreNuits,
                    showFiltreDistance: showFiltreDistance,
                    showFiltreDuration: showFiltreDuration,
                    showFiltreElevation: showFiltreElevation,
                    lib: '',
                    suggestions: []
                }
            },
            mounted: function() {
                fetch(apidae.site_url + uri + '/json')
                    .then(stream => stream.json())
                    .then(data => {
                        this.params = data.params;
                        this.groupesFiltres = data.filtres;
                        this.suggestions = data.items;
                        this.loading = false;
                    })
                    .catch(error => console.error(error))
            },
            methods: {
                callfilters: function(event) {
                    // console.log(event);
                    loadData = true;
                    let apiUrl = apidae.site_url + uri + '/json';
                    let query = '?tri=triEvenement&searchByMap=0&zl=&slt=&slg=&nlt=&nlg=';

                    if (event.target.classList.contains('pricevent')) {
                        this.pmin = Number(event.target.getAttribute('data-pmin'))
                        this.pmax = Number(event.target.getAttribute('data-pmax'))
                    }
                    query += '&pmin=' + this.pmin + '&pmax=' + this.pmax;

                    if (event.target.classList.contains('nombrejoursevent')) {
                        this.njmin = Number(event.target.getAttribute('data-njmin'))
                        this.njmax = Number(event.target.getAttribute('data-njmax'))
                    }
                    query += '&njmin=' + this.njmin + '&njmax=' + this.njmax;

                    if (showFiltreDate) {
                        query += '&rbl=calendar&dd=' + this.params.dateDebut + '&df=' + this.params.dateFin;
                    }

                    if (event.target.classList.contains('filterlibevent')) {
                        this.lib = String(event.target.value)
                    }
                    query += '&lib=' + this.lib

                    // console.log(this.groupesFiltres);
                    let cgroupesFiltres = this.groupesFiltres;
                    cgroupesFiltres.forEach(cgroupefiltres => {
                        let cfiltres = cgroupefiltres.listeFiltre;
                        cfiltres.forEach(cfiltre => {
                            // console.log(cfiltre.selected);
                            if (cfiltre.selected) {
                                // console.log(cfiltre.idFiltre);
                                query += '&filter' + cfiltre.idFiltre + '=' + cgroupefiltres.idGroupe;
                            }
                        });
                    });
                    // console.log(cgroupesFiltres);
                    // console.log(query);

                    fetch(apiUrl + query)
                        .then(stream => stream.json())
                        .then(data => {
                            this.groupesFiltres = data.filtres;
                            this.suggestions = data.items;
                        })
                        .catch(error => console.error(error))
                },
                submitfilters: function(event) {
                    let query = uri + '?tri=triEvenement&searchByMap=0&zl=&slt=&slg=&nlt=&nlg=&njmin=0&njmax=8&pmin=' + this.pmin + '&pmax=' + this.pmax + '&njmin=' + this.njmin + '&njmax=' + this.njmax + '&lib=' + this.lib;
                    if (showFiltreDate) {
                        query += '&rbl=calendar&dd=' + this.params.dateDebut + '&df=' + this.params.dateFin;
                    }
                    let cgroupesFiltres = this.groupesFiltres;
                    cgroupesFiltres.forEach(cgroupefiltres => {
                        let cfiltres = cgroupefiltres.listeFiltre;
                        cfiltres.forEach(cfiltre => {
                            // console.log(cfiltre.selected);
                            if (cfiltre.selected) {
                                console.log(cfiltre.idFiltre);
                                query += '&filter' + cfiltre.idFiltre + '=' + cgroupefiltres.idGroupe;
                            }
                        });
                    });
                    // console.log(apidae.site_url + uri);
                    window.location = apidae.site_url + query;
                }
            }
        });
    })
}